/* app/js/src/components/calendar/marker-popover/marker-popover.component.scss */
.cursor-pointer {
  cursor: pointer;
}
.trigger {
  display: flex;
  align-items: center;
  width: 348px;
  height: 55px;
  background-color: white;
  cursor: pointer;
  margin-bottom: 6px;
}
.trigger .text {
  display: flex;
  align-items: center;
  margin-left: 15px;
  font-size: 12px;
  color: #2dbbfc;
  font-weight: 600;
}
.trigger .plus-sign {
  display: flex;
  align-items: center;
  font-size: 24px;
  margin-left: 20px;
}
.background-overlay {
  position: fixed;
  width: 100%;
  height: 100%;
  background: #000;
  opacity: 0.25;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.popover-container {
  width: 567px;
  height: 639px;
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.2);
  border: solid 1px #e1e6eb;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: white;
  z-index: 100;
}
.close-popover {
  position: absolute;
  top: 24px;
  right: 20px;
  cursor: pointer;
}
.popup-screen {
  display: flex;
  align-items: center;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
}
.screen-hidden {
  display: none;
}
.new-marker-title {
  color: #2dbbfc;
  font-weight: 600;
  font-size: 20px;
  margin-top: 184px;
  line-height: 27.24px;
}
.instructions {
  font-size: 14px;
  font-weight: 400px;
  margin-top: 11px;
}
.buttons-container {
  display: flex;
  margin-top: 50px;
}
.button {
  display: flex;
  flex-direction: column;
  text-align: center;
  width: 205.29px;
  height: 163px;
  border: 1px solid #dfe2e6;
  font-size: 18px;
  font-weight: 600;
  align-items: center;
  cursor: pointer;
}
.scte-button {
  margin-right: 18.71px;
}
.marker-icon {
  margin-top: 33.48px;
}
.scte-text {
  width: 100px;
  margin-top: 16.74px;
  display: flex;
  justify-content: center;
}
.dtmf-text {
  margin-top: 22.91px;
}
.new-scte-title {
  color: #2dbbfc;
  font-weight: 600;
  font-size: 20px;
  margin-top: 159px;
  margin-bottom: 32px;
}
.scte-label {
  display: inline-block;
  font-size: 14px;
  font-weight: 400;
  padding-bottom: 15px;
}
.large-input {
  width: 438px;
  height: 39px;
  border: 1px solid #c2ccdb;
  font-size: 14px;
  font-weight: 400;
  padding: 12px;
}
.input-bottom-margin {
  margin-bottom: 18px;
}
.create-button {
  display: block;
  margin: 0 auto;
  margin-top: 64px;
  width: 96px;
  height: 33px;
  background: #2dbbfc;
  border-radius: 5px;
  font-size: 16px;
  font-weight: 600;
  color: white;
  border: none;
}
.create-scte-button {
  margin-top: 64px;
}
.new-dtmf-title {
  color: #2dbbfc;
  font-weight: 600;
  font-size: 20px;
  margin-top: 47px;
  margin-bottom: 18px;
}
.form-row {
  display: flex;
}
.small-input {
  height: 39px;
  width: 210px;
  border: 1px solid #c2ccdb;
  font-size: 14px;
  font-weight: 400;
  padding: 12px;
}
.input-right-margin {
  margin-right: 18px;
}
.create-dtmf-button {
  margin-top: 31px;
}
.required-input-border {
  border: 1px solid red;
}
/*# sourceMappingURL=marker-popover.component.css.map */
